export default __webpack_public_path__ + "static/media/pickup.d5909abb.svg";